import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'components/Modal';
import Button from 'components/Button';
import TextField from 'components/TextField';
import { actions as toastrActions } from 'react-redux-toastr';
import { Container, WrapperButtons, WrapperInput } from './styles';

function ModalJustificativaCancelamentoMdfe({ open, onClose, onConfirm, quantidadeMdfe = 0 }) {
  const dispatch = useDispatch();
  const [justificativa, setJustificativa] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setJustificativa('');
      setLoading(false);
    }
  }, [open]);

  const handleSubmit = async () => {
    if (!justificativa || justificativa.trim() === '') {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro',
          message: 'Por favor, informe a justificativa para o cancelamento',
        })
      );
      return;
    }

    if (justificativa.trim().length < 15) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro',
          message: 'A justificativa deve ter pelo menos 15 caracteres',
        })
      );
      return;
    }

    setLoading(true);
    try {
      if (onConfirm) {
        await onConfirm(justificativa.trim());
      }
      handleClose();
    } catch (error) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro',
          message: error.message || 'Erro ao processar cancelamento',
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setJustificativa('');
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose} title="Justificativa para Cancelamento">
      <Container>
        <div style={{ marginBottom: '15px', color: '#333', fontSize: '14px', fontWeight: 'normal' }}>
          Você está cancelando <strong style={{ color: '#333', fontWeight: 'bold' }}>{quantidadeMdfe}</strong> MDF-e(s). Informe a justificativa:
        </div>
        
        <WrapperInput>
          <TextField
            label="Justificativa"
            name="justificativa"
            value={justificativa}
            onChange={(e) => {
              const value = e.target.value;
              setJustificativa(value);
            }}
            fullWidth
            multiline
            color='primary'
            rows={4}
            placeholder="Digite a justificativa para o cancelamento do(s) MDF-e(s)..."
            inputProps={{
              maxLength: 255,
              style: { color: '#333' },
            }}
            InputLabelProps={{
              style: { color: '#666' },
            }}
            autoFocus
          />
        </WrapperInput>

        <div style={{ fontSize: '12px', color: '#666', marginTop: '-10px', marginBottom: '15px' }}>
          Mínimo de 15 caracteres
        </div>

        <WrapperButtons>
          <Button
            label="Cancelar"
            onClick={handleClose}
            color="secondary"
            margin="0 10px 0 0"
            disabled={loading}
          />
          <Button
            label={loading ? 'Processando...' : 'Confirmar Cancelamento'}
            onClick={handleSubmit}
            color="primary"
            disabled={loading || !justificativa || justificativa.trim().length < 15}
          />
        </WrapperButtons>
      </Container>
    </Modal>
  );
}

export default ModalJustificativaCancelamentoMdfe;

